import {
  Button,
  Checkbox,
  Group,
  HoverCard,
  NumberFormatter,
  Text,
  ThemeIcon,
  Tooltip,
} from "@mantine/core";
import { useCallback, useMemo } from "react";
import { useLeadsContainerStore } from "../../../../../stores/LeadsStore";
import { useLanguage } from "../../../../../stores/LanguageStore";
import HeaderMenu from "./HeaderMenu";
import { IconInfoCircle } from "@tabler/icons-react";

const ContainerHeader = ({ container }) => {
  const lang = useLanguage((s) => s.language);
  const containerColor = useMemo(
    () => `#${container?.color || "333333"}`,
    [container]
  );
  const selectedIds = useLeadsContainerStore((s) => s.selectedIds);
  const setSelectedIds = useLeadsContainerStore((s) => s.setSelectedIds);
  const selectedColumns = useLeadsContainerStore((s) => s.selectedColumns);
  const setSelectedColumns = useLeadsContainerStore(
    (s) => s.setSelectedColumns
  );
  const unselectedIds = useLeadsContainerStore((s) => s.unselectedIds);
  const setUnselectedIds = useLeadsContainerStore((s) => s.setUnselectedIds);

  const toggleSelectAll = useCallback(() => {
    // Toggle true
    if (!selectedColumns.includes(container.id)) {
      setSelectedColumns([...selectedColumns, container.id]);
      setSelectedIds({ ...selectedIds, [container.id]: [] });
      setUnselectedIds({ ...unselectedIds, [container.id]: [] });
    }
    // Toggle false
    else {
      setSelectedColumns(selectedColumns.filter((x) => x !== container.id));
      setSelectedIds({ ...selectedIds, [container.id]: [] });
      setUnselectedIds({ ...unselectedIds, [container.id]: [] });
    }
  }, [
    selectedIds,
    container.id,
    setSelectedColumns,
    setSelectedIds,
    setUnselectedIds,
    unselectedIds,
    selectedColumns,
  ]);

  return (
    <Group
      w={"100%"}
      style={{
        border: "1px solid #00000021",
        borderRadius: 12,
        // background: containerColor + "0a",
        overflow: "hidden",
      }}
      wrap="nowrap"
      className="prm-header"
      gap={6}
    >
      <Tooltip
        label={`${
          selectedColumns.includes(container.id)
            ? lang.prm.container.deselect
            : lang.prm.container.select
        } ${lang.prm.container.all_prospect_in} ${container.name}`}
      >
        <Button
          color={containerColor}
          disabled={!container?.loaded}
          onClick={toggleSelectAll}
          variant={selectedColumns.includes(container.id) ? "filled" : "light"}
          // size="compact-sm"
          px={6}
          py={4}
          miw={64}
          h={"100%"}
          fz={14}
          fw={500}
        >
          <NumberFormatter value={container?.total} thousandSeparator=" " />
        </Button>
      </Tooltip>

      <Group px={"sm"} py={"xs"} flex={1}>
        <Tooltip label={container.name}>
          <Text
            fw={500}
            fz={14}
            flex={1}
            truncate
            //   {...attributes}
            //   {...listeners}
            pos={"relative"}
            style={{ zIndex: 65 }}
          >
            {container.name}
          </Text>
        </Tooltip>

        {container.id === "out_of_office" && (
          <HoverCard position="top" width={300} withArrow offset={0}>
            <HoverCard.Target>
              <ThemeIcon variant="subtle">
                <IconInfoCircle />
              </ThemeIcon>
            </HoverCard.Target>

            <HoverCard.Dropdown>
              <Text>{lang.prm.container.out_of_office_text}</Text>
            </HoverCard.Dropdown>
          </HoverCard>
        )}

        <Group wrap="nowrap" ml={"auto"} gap={"xs"}>
          <HeaderMenu container={container} />
        </Group>
      </Group>
    </Group>
  );
};

export default ContainerHeader;
